// Texter vum « Erliefnes » op der Startsäit: de Kappbanner
// (Hero/HeroSection.jsx), den Oflaf a 4 Fotoen (HowItWorks.jsx) an déi
// spillbar Demo (GameDemo.jsx).
// Iwwersetzung vu fr/experience.js — genee déiselwecht Schlësselen.
export default {
  /* ----------------------------------------------------- HeroSection */

  'hero.badge': '🤫 Dir wësst et scho. Si nach net.',

  // Den Titel steet op zwou Zeilen, déi zweet am Faarfverlaf.
  'hero.titre.ligne1': 'Loosst si entdecken',
  'hero.titre.ligne2': 'DAT GROUSST GEHEIMNIS',

  // Saz, deen ronderëm d’<strong> an d’<br /> geschnidden ass: dat Fett hëlt
  // de Mëssverständnes ewech (« net DIR entdeckt d’Geschlecht »).
  'hero.accroche.fort': 'Dir kennt d’Geschlecht vum Bëbee. Är Léifsten nach net.',
  'hero.accroche.texte':
    'Dëst Spill léisst si roden: zwou Equipen, 11 Froen „Mamma oder Papa?“, an e lescht Puzzlestéck zum Rubbelen, dat et jidderengem zur selwechter Zäit verréit.',
  'hero.accroche.objet': '📦 Eng richteg Spillschachtel aus Kartong, bei Iech heem geliwwert.',

  'hero.cta.offre': '✨ Entdeckt eist Ugebot',
  'hero.cta.enSavoirPlus': '↓ Méi gewuer ginn',

  'hero.atout.pieces': '12 Stécker, net 1000',
  'hero.atout.joueurs': 'Vu 2 bis 10 Spiller',
  'hero.atout.duree': '20 Minutten',

  'hero.imageAlt':
    'Joyful Reveal — Gender-Reveal-Spill vu Mirum Games: de Puzzel mat den zwee Bieren, „baby boy“ oder „baby girl“',
  'hero.scroll': 'Scrollt fir z’entdecken',

  /* ------------------------------------------------------ HowItWorks */

  'how.badge': 'De Szenario',
  'how.titre': 'Invitéiert se op en Iessen. Sot näischt.',
  'how.description':
    'Fir si ass et en Iessen wéi all anert. Beim Dessert proposéiert Dir e klengt Gesellschaftsspill … an do fänkt alles un. Zwanzeg Minutte méi spéit wësse se et.',

  'how.etape1.titre': '„Spille mer eng Ronn?“',
  'how.etape1.texte':
    'D’Spillkëscht kënnt op den Dësch. Jiddereen wielt säi Camp — Team Meedchen oder Team Jong — an Dir stellt déi éischt vun den eelef Froen „Mamma oder Papa?“.',
  'how.etape1.alt':
    'Den Inhalt vum Spill Joyful Reveal: d’Schachtel, de Froebou an déi zwee Stoffsäckelcher',

  'how.etape2.titre': 'Wien äntwere wëll, mécht Kaméidi',
  'how.etape2.texte':
    'Keng Hand an d’Luucht: Kannerspillsaachen an d’Hand, Rasselen an esou weider, a sou vill Kaméidi maache wéi méiglech. Dir decidéiert, wéi eng Equipe äntwert.',
  'how.etape2.alt': 'Déi zwee Stoffsäckelcher, déi un déi zwou Equipen iwwerreecht ginn',

  'how.etape3.titre': 'D’Stëmmung klëmmt ëmmer méi',
  'how.etape3.texte':
    'D’Equipe, déi Dir net gewielt hutt, mécht bei der nächster Fro duebel sou vill Kaméidi. Dann déi aner. All richteg Äntwert bréngt e Stéck an; nom eeleften leeën all zesummen de Puzzel.',
  'how.etape3.alt':
    'De Joyful-Reveal-Puzzel fäerdeg a sengem gëllene Kader, d’Rubbelstéck nach gro',

  'how.etape4.titre': 'Dat zwieleft Stéck gëtt gerubbelt',
  'how.etape4.texte':
    'Eng lescht Fro, ee Gewënner. Kuerz Rou, dann de Gejäiz: de Moment, vun deem Är Léifsten nach Joren erzielen.',
  'how.etape4.alt':
    'Eng Hand rubbelt mat enger Mënz dat lescht Puzzlestéck fräi: d’Wuert GIRL erschéngt',

  // Schlusssaz, deen ronderëm de Link geschnidden ass: « <link> — Fortsetzung ».
  'how.lienRegles': 'Déi komplett Spillregele liesen',
  'how.lienReglesSuite': '— Froen dobäi, prett fir ze drécken.',

  // « Le secret des parents » — carte affichée sous le scénario (accueil,
  // fiche produit) et repliée sur la page des règles, que le QR code de la
  // boîte ouvre aussi pour les invités.
  'secret.label': '🤫 Nëmme fir d’Elteren',
  'secret.titre': 'D’Geheimnis vun den Elteren',
  'secret.texte':
    'Nëmmen Dir kennt d’Froen am Viraus, an Dir wielt, wéi eng Equipe äntwert. Dir kënnt dem Gléck also ganz diskret e bëssen nohëllefen.',
  'secret.parrain':
    'Dir wëllt een froen, fir Pätter oder Gotte ze ginn? Gitt senger oder hirer Equipe d’Wuert, wann Dir wësst, datt hien oder hatt d’Äntwert kennt. Stellt am Finale eng Fro, där hir Äntwert eng Zuel ass, déi Dir him oder hir e puer Deeg virdrun uvertraut hutt. Et ass seng oder hir Hand, déi dat lescht Stéck fräirubbelt.',
  'secret.chute': 'An déi nächst Fro, déi stellt Dir.',
  'secret.afficher': '👀 Geheimnis weisen (nëmme fir d’Elteren)',

  /* -------------------------------------------------------- GameDemo */

  'demo.badge': 'Probéiert et elo — eng Partie am Schnellduerchgang',
  'demo.titre': 'Spillt mat, wéi um grousse Dag',
  'demo.intro':
    'Zwou Equipen, eelef Froen, e Puzzle, dee Form kritt. Dat zwieleft Stéck gëtt gerubbelt — an dat verréit alles. Hei ass d’Partie, an enger Minutt.',

  // Meldunge fir Bildschiermliesgeräter (aria-live): all Etapp vun der Demo.
  'demo.etape.pari': 'Schrëtt 1 vu 4 — bilt Är Equipe',
  'demo.etape.questions': 'Schrëtt 2 vu 4 — gewannt d’Stécker',
  'demo.etape.cascade': 'Schrëtt 2 vu 4 — de Puzzle fëllt sech',
  'demo.etape.subsidiaire': 'Schrëtt 3 vu 4 — d’Schätzfro',
  'demo.etape.grattage': 'Schrëtt 4 vu 4 — déi grouss Uskënnegung',
  'demo.etape.final': 'Partie eriwwer',
  'demo.aria.resultat': 'Resultat vun der Demo: et ass {mot}.',

  // Dat ausgeloust Geschlecht, sou wéi et an d’Sätz passt: « Et ass {mot}! »
  'demo.resultat.fille': 'e MEEDCHEN',
  'demo.resultat.garcon': 'e JONG',

  'demo.puzzle.aria': 'Puzzle vun der Demo: {n} Stéck(er) vun 12 geluecht',
  'demo.puzzle.pieceAGratter': 'D’Rubbelstéck',
  'demo.puzzle.compteur': '🧩 {n}/12 Stécker — dat richtegt Motiv vum Puzzle (14 × 21 cm)',

  'demo.pari.etiquette': 'Schrëtt 1 — wéi an de Regelen: mir bilden d’Equipen',
  'demo.pari.titre': 'A Dir — wat seet Äert Gefill?',
  'demo.pari.fille': '💗 Ech tippen op e MEEDCHEN',
  'demo.pari.garcon': '💙 Ech tippen op e JONG',
  'demo.pari.note':
    'Um grousse Dag geet jiddereen an d’Equipe vu sengem Bauchgefill. Hei gëtt d’Resultat ausgelous — bei Iech doheem ass et Äert richtegt Geheimnis.',

  'demo.questions.etiquette': 'Fro {numero} vun 11 — aus dem richtege Froebou',
  // Richteg Froen aus dem Froebou an der Schachtel (ursprénglech Nummeren).
  'demo.question.5': 'Wie séngt d’Schlofliddercher op eng katastrophal Manéier?',
  'demo.question.7': 'Wie kräischt bei Kannerfilmer?',
  'demo.question.11':
    'Wie géif de Bëbee ongeschéckt opwecken, well en op eng Spillsaach trëppelt, déi Kaméidi mécht?',
  'demo.questions.maman': '🤱 Mamma',
  'demo.questions.papa': '🧔 Papa',
  'demo.questions.gagne': '🧩 Stéck gewonnen! Et geet an de Puzzle…',
  'demo.questions.note':
    'Am richtege Spill entscheeden déi zukünfteg Elteren — an Dir musst méi séier äntweren wéi déi aner Equipe.',

  'demo.cascade.titre': '…an déi aacht aner gewannt Dir genau esou.',
  'demo.cascade.texte':
    'Fro no Fro fëllt sech de Puzzle — fir d’Demo kritt Dir se geschenkt. Geschwënn bleift nëmmen nach ee Stéck iwwreg.',

  'demo.subsidiaire.etiquette':
    'Et feelt nach ee Stéck — d’Schätzfro entscheet, wien et rubbelt',
  // D’DEMO-Fro — mat Wëllen eng ANER wéi déi richteg Schätzfro vum Spill,
  // fir datt d’Haaptsäit d’Iwwerraschung vum grousse Dag ni verréit. Dofir
  // dierf d’Demo hei d’Äntwert ginn.
  'demo.subsidiaire.question':
    'Wéi vill Stonnen den Dag schléift en Neigebuerenen am Duerchschnëtt?',
  'demo.subsidiaire.labelEstimation': 'Är Schätzung vun der Zuel vu Stonnen',
  'demo.subsidiaire.placeholder': 'Är Schätzung…',
  'demo.subsidiaire.valider': 'Ech probéieren et!',
  // Äntwertsaz, geschnidden ronderëm d’<strong> (déi agedroe Schätzung) an
  // d’<sup> (d’Ordinalendung vun « 12e »). Op Lëtzebuergesch schreift een d’
  // Uerdnungszuel mat engem Punkt (12.) — den <sup> bleift dofir eidel.
  'demo.subsidiaire.retourAvant': 'Är Schätzung:',
  'demo.subsidiaire.retourApres':
    '. D’Äntwert: ronn 16 bis 17 Stonnen den Dag! Um grousse Dag kënnt eng aner Fro — déi steet mat Äntwert an de Spillregele gedréckt 😉.',
  'demo.subsidiaire.retourPiece': 'De Spiller, deen am nootsten drun ass, gewënnt dat 12.',
  'demo.subsidiaire.retourExposant': '',
  'demo.subsidiaire.retourFin': 'Stéck. Haut ass dës Éier fir Iech.',
  'demo.subsidiaire.cta': '🪙 Dat 12. Stéck rubbelen',

  'demo.grattage.etiquette': 'Dat 12. Stéck läit an Ären Hänn',
  // Déi zwou Zeilen, déi op d’Sëlwerschicht gemoolt ginn (canvas).
  'demo.grattage.grattez': '✨ RUBBELEN ✨',
  'demo.grattage.doigtOuSouris': 'Fanger oder Maus',
  'demo.grattage.aria': 'D’Stéck ass gerubbelt: et ass {mot}.',
  'demo.grattage.revele': 'Et ass {mot}! D’Stéck geet an de Puzzle…',
  'demo.grattage.revelerMaintenant': 'Direkt opdecken',
  'demo.grattage.revelerSansGratter': 'Opdecken ouni ze rubbelen',

  'demo.final.titre': 'Et ass {mot}!',
  'demo.final.pariGagne': 'An Är Equipe hat richteg gesinn. Respekt.',
  'demo.final.pariPerdu': 'Déi aner Equipe hat Recht — dat passéiert de Beschten.',
  // Saz, deen ronderëm d’<strong> geschnidden ass: virdrun / dat fett Wuert / duerno.
  'demo.final.texteAvant': '…an dëser Demo op alle Fall. Um grousse Dag ass et',
  'demo.final.texteFort': 'Äert',
  'demo.final.texteApres':
    'Geheimnis, dat Är Léifsten entdecken — an de fäerdege Puzzle (14 × 21 cm, genee d’Format vun engem Kader) bleift als Souvenir.',
  'demo.final.ctaBoutique': '🛒 Dat wëll ech doheem erliewen',
  'demo.final.rejouer': '↺ Nach eng Kéier spillen',
};
